import React, { useState } from 'react'
import useSingleStation from '../../../hooks/useSingleStation';
import useChargingSessionAdmin, { useChargingSessionSumAnalysis } from '../../../../chargingSession/hooks/useChargingSession';
import { Filter } from '../../../../../utils/genericAPI/useGenericAPI';
import { ChargingSessionPatch } from '../../../../chargingSession/types/chargingSession.types';
import { numberFormaterString } from '../../../../../utils/numberFormater';
import { useFilterAnalysis } from '../../../../../common/analysis/filter/hook';
import FilterPresenter from '../../../../../common/analysis/filter/components/Filter/FilterPresenter';
import ModalCard from '../../../../../common/components/molecule/ModalCard/ModalCard';
import { converteTitle } from '../../../../../common/analysis/utils/graph.utils';
import ButtonPlus from '../../../../../common/components/atom/ButtonPlus/ButtonPlus';

export const NbChargingSessionsProvided = ({ stationId }: { stationId?: string, preFilter?: Filter<ChargingSessionPatch> }) => {

        const { stationId: paramId } = useSingleStation()
    
        const stationIdFound = stationId || paramId;
        const {filter} = useFilterAnalysis()

        const {getAllChargingSession} = useChargingSessionAdmin({
            filter: {
                cs_station: `=${stationIdFound}`,
                cs_create_at: filter.startDate && filter.startDate ? `<btw>[${filter.startDate},${filter.stopDate}]` : undefined,
            },
            pageSize: 1,
            hookId: "nbcsp",

        })

        if (getAllChargingSession.isLoading) {
            return (
                <>...</>
            )
        }
        if (getAllChargingSession.isError) {
            return <>-</>
        }

        return (
            <>{getAllChargingSession.data?.pagination.total_count}</>
        )


}


export const TotalMoney = ({ stationId }: { stationId?: string, preFilter?: Filter<ChargingSessionPatch> }) => {
    const {filter} = useFilterAnalysis()
    const { stationId: paramId } = useSingleStation()

    const stationIdFound = stationId || paramId;


    const { sumChargingSessionAnalysisQuery: getSumQuery} = useChargingSessionSumAnalysis("cs_price",{
        preFilter: {
            cs_station: `=${stationIdFound}`,
            cs_create_at: filter.startDate && filter.startDate ? `<btw>[${filter.startDate},${filter.stopDate}]` : undefined,
        },
    })

    if (getSumQuery.isLoading) {
        return (
            <>...</>
        )
    }
    if (getSumQuery.isError) {
        return <>-</>
    }

    if (!getSumQuery.data || !getSumQuery.data?.data || getSumQuery.data?.data.length === 0) {
        return <>0</>
    }

    return (
        <>{numberFormaterString(getSumQuery.data?.data[0].total)}</>
    )
}

export interface FilterTimeWindowBtnProps {
    openButtonRender?: (options?: {handleOpen: () => void, timeLabel?: string}) => React.JSX.Element;
}
export const FilterTimeWindowBtn = ({openButtonRender}: FilterTimeWindowBtnProps) => {

    const {filter} = useFilterAnalysis()
    const [isOpen, setIsOpen] = useState(false)
    const handleClose = () => {
        setIsOpen(false)
    }
    const labelTime = converteTitle(filter.startDate|| "", filter.stopDate|| "")

    return <>

            {
                openButtonRender ?
                openButtonRender({handleOpen: () => setIsOpen(true), timeLabel: labelTime}) :
            
            <ButtonPlus onClick={() => setIsOpen(true)} iconType="time" >
                {labelTime}
            </ButtonPlus>
        }     
            <ModalCard withIsOpenModel isOpen={isOpen} onClose={handleClose}>
                 <FilterPresenter handleClose={handleClose}/>
            </ModalCard>
            </>


}